<style lang="less" scoped>
  @import "../../../style/theme.less";
</style>

<template>
  <div>
    <a-row type="flex" :gutter="[16,16]">
      <a-col flex="auto">
        <div v-if="title" class="ant-descriptions-title">{{ title }}</div>
      </a-col>
      <a-col flex="60px" v-if="editable === true">
        <a-button
          type="primary"
          shape="circle"
          icon="edit"
          @click="() => $emit('edit')"
        />
      </a-col>
    </a-row>

    <a-table
      :columns="columns"
      :data-source="formattedConditions"
      :pagination="false"
      :rowKey="({ id }) => id"
    >

      <span slot="capitalise" slot-scope="data">{{ data | capitalise }}</span>
    </a-table>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex';

const columns = [
  {
    title: 'Field',
    dataIndex: 'field',
    scopedSlots: { customRender: 'capitalise', },
  }, {
    title: 'Condition',
    dataIndex: 'condition',
  }, {
    title: 'Value',
    dataIndex: 'value',
    scopedSlots: { customRender: 'capitalise', },
  },
];

export default {
  name: 'admin.conditions-display',

  data: () => ({
    columns,
  }),

  props: ['conditions', 'editable', 'title',],

  mounted() {
    return Promise.all([
      this.listPersonalityTraits(),
      this.listConstants(),
    ]);
  },

  computed: {
    ...mapState('admin', ['constants',]),

    validOperators() {
      return Object.keys();
    },

    formattedConditions() {
      return Object.keys(this.conditions).reduce((acc, key) => {
        const condition = this.conditions[key];

        acc.push(...Object.keys(condition).map(operator => this.formatConditionPartial({
          key,
          condition: condition[operator],
          operator,
        })));

        return acc.filter(v => !!v);
      }, []);
    },
  },

  methods: {
    ...mapActions('admin', ['listPersonalityTraits', 'listConstants',]),
    ...mapGetters('admin', ['resolvePersonalityTrait',]),

    formatConditionPartial({ key, condition, operator, }) {
      const { conditions: { typeDescriptors, operatorDescriptors, types, operators, }, genders: { genderDescriptors, }, } = this.constants;
      if (!condition || !Object.keys(operators).includes(operator)) {
        return null;
      }

      const inputDescriptor = typeDescriptors[key] || this.resolvePersonalityTrait()(key).descriptor;

      const { type, value, correction = {}, inclusive, } = condition;

      const operatorDescriptor = `${operatorDescriptors[operator]} ${inclusive === false ? '' : 'or Equal'}`;

      const valueDescriptor = {
        [types.literal]: genderDescriptors[value] || value,
        [types.personalityTrait]: this.resolvePersonalityTrait()(value).descriptor,
      }[type] || typeDescriptors[type];

      const correctionDescriptor = Object.keys(correction).reduce((acc, correctionType) => {
        if (correctionType === 'add') {
          return `${acc} + ${correction.add}`.trim();
        } else if (correctionType === 'subtract') {
          return `${acc} - ${correction.subtract}`.trim();
        }

        return acc;
      }, '');

      return {
        id: `${key}:${operator}`,
        field: inputDescriptor,
        condition: operatorDescriptor,
        value: valueDescriptor + correctionDescriptor,
      };
    },
  },
};
</script>
